import React from 'react';
import styles from './Icon.module.css';

export interface IconProps {
  name: string;
  size?: 'sm' | 'lg';
  shape?: 'rounded';
  color?: string | 'accent';
  disabled?: boolean;
  className?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  size,
  shape,
  color,
  disabled = false,
  className = '',
}) => {
  const getIconClasses = () => {
    const classes = ['uc-icon', styles.icon];

    if (size) {
      classes.push(`icon-size--${size}`);
    }

    if (shape === 'rounded') {
      classes.push('icon-shape--rounded');
    }

    if (color === 'accent') {
      classes.push(styles.colorAccent);
    } else if (color) {
      classes.push(`icon-color--${color}`);
    }

    if (disabled) {
      classes.push('uc-icon--disabled', styles.disabled);
    }

    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return <i className={getIconClasses()}>{name}</i>;
};

export default Icon;
